// src/store/index.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    isVIP: false, // 全局状态
  },
  mutations: {
    // 更新用户状态的 mutation
    setIsVIP(state, status) {
      state.isVIP = status;
    },
  },
  actions: {
    // 异步获取用户状态的 action
    async fetchUserStatus({ commit }) {
        // 封装一个 Promise，轮询检查 pywebview 是否就绪
        const waitForPywebview = () => {
            return new Promise((resolve, reject) => {
                let maxTries = 10; // 最大重试次数
                const interval = setInterval(() => {
                    if (window.pywebview && window.pywebview.api) {
                        // pywebview 已经加载完成
                        clearInterval(interval);
                        resolve();
                    } else {
                        // pywebview 未加载完成，继续检测
                        maxTries--;
                        if (maxTries <= 0) {
                            clearInterval(interval); // 达到最大重试次数，停止轮询
                            reject(new Error('pywebview 未能加载'));
                        }
                    }
                }, 500); // 每隔500毫秒检测一次
            });
        };

        try {
            // 等待 pywebview 就绪
            await waitForPywebview();

            // pywebview 已就绪，获取用户状态
            const savedData = await window.pywebview.api.getActiveStatus();
            console.log("in store index.js and the savedata is " + savedData.activationStatus);
            
            if (savedData) {
                commit('setIsVIP', savedData.activationStatus === '正常' || savedData.activationStatus === '试用');
            }
        } catch (error) {
            console.error('获取用户状态失败:', error);
        }
    }
,
  },
  getters: {
    isVIP: (state) => state.isVIP,
  },
});
